/**
 * Combined unread count for the badged actions that fold into the mobile
 * header's three-dots (⋮) overflow menu.
 *
 * On mobile the low-frequency, badge-bearing icons — the messaging inbox, the
 * announcements bell, and the Mail/Files quick shortcuts — are collapsed into
 * the overflow menu (see ui-navigation.md § Header). A folded-away unread must
 * never be hidden, so the ⋮ trigger surfaces the sum of those counts. This hook
 * is that single source of truth, reusing each surface's own unread hook so the
 * numbers can never drift from the rows inside the menu.
 *
 * Not memoized: it only sums a handful of numbers, and its inputs already come
 * from memoized/cached query hooks.
 */

import { useMessagingUnreadSummary } from '../../modules/messaging/hooks/useMessagingApi';
import { useUserAnnouncements } from '../../modules/software_factory/components/delivery/AnnouncementsProvider';
import { useMailFilesShortcuts } from './appBarShortcuts/useMailFilesShortcuts';

export function useOverflowMenuUnread(): number {
  const { data } = useMessagingUnreadSummary(5);
  const { unseenCount } = useUserAnnouncements();
  const { mail, files } = useMailFilesShortcuts();

  const messagingUnread = data?.total_unread ?? 0;
  const mailFilesUnread = [...mail, ...files].reduce(
    (sum, item) => sum + (item.unreadCount ?? 0),
    0,
  );

  return messagingUnread + unseenCount + mailFilesUnread;
}
